import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  serviceTypesApi,
  type CreateServiceTypeInput,
  type UpdateServiceTypeInput,
} from '../services/serviceTypesApi';
// Re-export ServiceType for consumers
export type { ServiceType } from '../services/serviceTypesApi';

export const serviceTypeKeys = {
  all: ['service-types'] as const,
  list: (includeInactive: boolean) => [...serviceTypeKeys.all, { includeInactive }] as const,
};

export function useServiceTypes(includeInactive: boolean) {
  return useQuery({
    queryKey: serviceTypeKeys.list(includeInactive),
    queryFn: () => serviceTypesApi.list(includeInactive),
    staleTime: 30_000,
  });
}

export function useCreateServiceType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateServiceTypeInput) => serviceTypesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: serviceTypeKeys.all });
    },
  });
}

export function useUpdateServiceType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateServiceTypeInput }) =>
      serviceTypesApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: serviceTypeKeys.all });
    },
  });
}

export function useDeleteServiceType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => serviceTypesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: serviceTypeKeys.all });
    },
  });
}
